import React, { type ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'next-i18next';
import { Tooltip, type TooltipProps } from '@/components/ui/Tooltip';
export const LanguageSelectorTooltip = (props: ComponentPropsWithoutRef<'div'> & Pick<TooltipProps, 'align' | 'side'> & {
  isHide: boolean;
}) => {
  const {
    t
  } = useTranslation(['common']);
  if (props.isHide) return props.children;
  return <Tooltip delayDuration={100} align={props.align || 'center'} side={props.side || 'left'} trigger={props.children} content={t('common.languageSelector.tooltip')} data-sentry-element="Tooltip" data-sentry-component="LanguageSelectorTooltip" data-sentry-source-file="LanguageSelectorTooltip.tsx" />;
};